import React, { useState } from 'react';
import { Box } from '@mui/material';
import { createReportRequest } from '../../../../api/reportApi';
import { DateRange } from './common';
import {
  useGetReport, getYear, useAreDatesValid, usePeriodTooLong,
} from '../utils';
import Selector from '../../../../components/Selectors/Selector';
import { REPORT_STATUS_NAMES, REPORTS_STATUSES } from '../../../../constants/lkCadastr/cadastrStorage';

import { fileTypes, report_type, reportTitles } from '../constants';
import { ReportTemplate } from './ReportTemplate';

const initialForm = {
  date_from: null,
  date_to: null,
  report_status: null,
};

const oldStatusOptions = [
  { id: 'paper_document_accepted', label: 'Бумажный документ принят', value: 'paper_document_accepted' },
];

const newStatusOptions = Object.entries(REPORTS_STATUSES)
  .filter(([key]) => key !== REPORT_STATUS_NAMES.formation)
  .map(([key, label]) => ({
    id: key,
    value: key,
    label,
  }));

export function MonitoringReport() {
  const [countReports, setCountReports] = useState(null);

  const getReports = async ({ form }) => {
    try {
      const response = await createReportRequest({
        format_type: fileTypes.json,
        report_type,
        kind: reportTitles.monitoring_status_reports,
        options: { ...form, report_status: form.report_status?.value },
      });

      setCountReports(response?.json_response?.count ?? 0);
    } catch (e) {
      console.error(e);
    }
  };

  function onChangeCallback({ name, form, makeRequest }) {
    if (name === 'report_status') makeRequest();
    if (form.report_status && (name === 'date_from' || name === 'date_to')) makeRequest();
  }

  const {
    form,
    loadingCountReports,
    onChange,
    clear,
    dateError,
    isCleared,
    setIsCleared,
  } = useGetReport({ onChangeCallback, getReports, initialForm });

  const {
    date_to,
    date_from,
    report_status,
  } = form;


  const areDatesValid = useAreDatesValid(date_from, date_to);

  const isPeriodTooLong = usePeriodTooLong({ date_from, date_to });

  const isStatusAvailable = !!(date_from && date_to && areDatesValid && !isPeriodTooLong);

  const toYear = getYear(date_to);
  const statusOptions = toYear < 2026 ? oldStatusOptions : newStatusOptions;

  return (
    <ReportTemplate
      counterOptions={{ loadingCountReports, countReports: !report_status ? 0 : countReports ?? 0, counterTitle: 'Количество отчетов:' }}
      clear={clear}
      visibleClear={date_from !== null || date_to !== null || report_status}
      error={dateError}
      reportTitle="Период заполнения сведений в Кадастр"
    >
      <Box sx={{ display: 'flex', gap: 2 }}>
        <DateRange
          date_to={date_to}
          date_from={date_from}
          onChange={onChange}
          isCleared={isCleared}
          setIsCleared={setIsCleared}
        />
      </Box>
      <Selector
        sx={{ minWidth: '540px' }}
        label="Статус отчета"
        name="report_status"
        value={report_status}
        onChange={onChange}
        options={statusOptions}
        disabled={!isStatusAvailable}
      />
    </ReportTemplate>
  );
}
